<template>
	<div>
		<el-form ref="form" :model="form" :rules="rules" label-width="160px" style="width: 600px">
			<el-form-item label="封面图片" prop="coverImage">
				<UploaderImage v-model="form.coverImage"></UploaderImage>
			</el-form-item>
			<el-form-item label="语言" prop="languageId">
				<Language v-model="form.languageId"></Language>
			</el-form-item>
			<el-form-item label="名称" prop="name">
				<el-input v-model="form.name" placeholder="请输入产品名称"></el-input>
			</el-form-item>
			<el-form-item label="SKU" prop="sku">
				<el-input v-model="form.sku" placeholder="请输入SKU"></el-input>
			</el-form-item>
			<el-form-item label="电池容量 (Wh)" prop="batteryCapacity">
				<el-input v-model="form.batteryCapacity" placeholder="请输入电池容量"></el-input>
			</el-form-item>
			<el-form-item label="电池转移效率" prop="batteryTransferEfficiency">
				<el-input v-model="form.batteryTransferEfficiency" placeholder="请输入电池转移效率"></el-input>
			</el-form-item>
			<el-form-item label="dod" prop="dod">
				<el-input v-model="form.dod" placeholder="请输入dod"></el-input>
			</el-form-item>
			<el-form-item label="可用电池容量 (Wh)" prop="usableBatteryCapacity">
				<el-input disabled v-model="form.usableBatteryCapacity" placeholder="请输入可用电池容量"></el-input>
			</el-form-item>
			<el-form-item label="兼容产品" prop="productIdList">
				<Product v-model="form.productIdList"></Product>
			</el-form-item>
			<el-form-item>
				<el-button @click="$router.back()">取消</el-button>
				<el-button type="primary" @click="handleSave">保存</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
import { add, edit, detail } from "@/api/battery";
import Language from "@/components/Language";
import Product from "@/components/Product";
import UploaderImage from "@/components/UploaderImage";
export default {
	components: { Language, Product, UploaderImage },
	data() {
		return {
			id: null,
			form: {
				name: "",
				sku: "",
				coverImage: "",
				languageId: null,
				productIdList: [],
				batteryCapacity: "",
				batteryTransferEfficiency: "",
				dod: "",
				usableBatteryCapacity: "",
			},
			countries: [],
			rules: {
				name: [{ required: true, message: "请输入产品名称" }],
				sku: [{ required: true, message: "请输入SKU" }],
			}
		}
	},
	computed: {
		calc() {
			if (!this.form.batteryCapacity || !this.form.batteryTransferEfficiency || !this.form.dod) return "";
			return (this.form.batteryCapacity * this.form.batteryTransferEfficiency * this.form.dod).toFixed(2);
		}
	},
	watch: {
		calc(val) {
			this.form.usableBatteryCapacity = val;
		}
	},
	mounted() {
		this.id = this.$route.query.id;
		if (this.id) {
			this.getDetail();
		}
	},
	methods: {
		getDetail() {
			detail(this.id).then(({ code, data }) => {
				if (code == 200) {
					this.form = {
						name: data.name,
						sku: data.sku,
						coverImage: data.coverImage,
						languageId: +data.languageId,
						productIdList: data.productIdList,
						batteryCapacity: data.batteryCapacity,
						dod: data.dod,
						batteryTransferEfficiency: data.batteryTransferEfficiency,
						usableBatteryCapacity: data.usableBatteryCapacity,
					};
				}
			})
		},
		handleSave() {
			this.$refs.form.validate(valid => {
				if (!valid) return;
				const params = {
					...this.form
				}
				if (!this.id) {
					add(params).then(({ code, message }) => {
						if (code == 200) {
							this.$message.success("添加成功");
							this.$router.back();
						} else {
							this.$message.error(message);
						}
					})
				} else {
					params.id = this.id;
					edit(params).then(({ code, message }) => {
						if (code == 200) {
							this.$message.success("修改成功");
							this.$router.back();
						} else {
							this.$message.error(message);
						}
					})
				}
			})
		}
	}
}
</script>

<style></style>